import * as React from "react";
import Svg, { G, Path, Defs, ClipPath, Rect } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#clip0_1096_12320)">
      <Path
        opacity={0.2}
        d="M21.9999 12.09V15.5C21.9999 17.75 18.3449 19.6062 13.5662 19.945C15.3049 20.6037 17.5499 21 19.9999 21C25.5224 21 29.9999 18.985 29.9999 16.5C29.9999 14.3225 26.5649 12.5075 21.9999 12.09Z"
        fill={props.color || "#A7BBF7"}
      />
      <Path
        opacity={0.2}
        d="M12 15C17.5228 15 22 12.9853 22 10.5C22 8.01472 17.5228 6 12 6C6.47715 6 2 8.01472 2 10.5C2 12.9853 6.47715 15 12 15Z"
        fill={props.color || "#A7BBF7"}
      />
      <Path
        d="M12 15C17.5228 15 22 12.9853 22 10.5C22 8.01472 17.5228 6 12 6C6.47715 6 2 8.01472 2 10.5C2 12.9853 6.47715 15 12 15Z"
        stroke={props.color || "#A7BBF7"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M2 10.5V15.5C2 17.985 6.4775 20 12 20C17.5225 20 22 17.985 22 15.5V10.5"
        stroke={props.color || "#A7BBF7"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M8 14.625V19.625"
        stroke={props.color || "#A7BBF7"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M21.9999 12.09C26.5649 12.5075 29.9999 14.3225 29.9999 16.5C29.9999 18.985 25.5224 21 19.9999 21C17.5499 21 15.3049 20.6037 13.5662 19.945"
        stroke={props.color || "#A7BBF7"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10 19.91V21.5C10 23.985 14.4775 26 20 26C25.5225 26 30 23.985 30 21.5V16.5"
        stroke={props.color || "#A7BBF7"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M24 20.625V25.625"
        stroke={props.color || "#A7BBF7"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16 14.625V25.625"
        stroke={props.color || "#A7BBF7"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1096_12320">
        <Rect width={32} height={32} fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
